import { Injectable } from '@angular/core';
import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';

@Injectable({
  providedIn: 'root',
})
export class InMemoryDataService implements InMemoryDbService {
  createDb() {
    const users = [
      // { id: 1, email: 'admin@example.com', password: 'admin123', role: 'admin' },
      // { id: 2, email: 'user@example.com', password: 'user123', role: 'user' }
    ];
    return { users };
  }

  // Optional custom login handling
  post(reqInfo: RequestInfo) {
    if (reqInfo.collectionName === 'login') {
      const { email, password } = reqInfo.utils.getJsonBody(reqInfo.req);
      const db: any = reqInfo.utils.getDb();
      const user = db.users.find((u: any) => u.email === email && u.password === password);
      return reqInfo.utils.createResponse$(() => ({
        body: user ? { success: true, user } : { success: false },
        status: 200
      }));
    }
    return undefined;
  }
}
